import * as Sentry from '@sentry/browser';

import { getEnv, getReleaseVersion } from './config';

export function configureSentry() {
  Sentry.init({
    beforeSend: (
      event: Sentry.SentryEvent,
      hint?: {},
    ): Sentry.SentryEvent | null | Promise<Sentry.SentryEvent | null> => {
      if (event.exception && event.exception.values) {
        event.exception.values.forEach(sanitizeError);
      }
      return event;
    },
    dsn: 'https://8a0e8db57d9b44ad99f2d1275d3ae764@sentry.io/1396188',
    environment: getEnv(),
    release: getReleaseVersion(),
    // Only send events in production
    sampleRate: __ENV_PROD__ ? 1 : 0,
  });
}

interface SentryTags {
  [tagName: string]: string;
}

export function captureException(e: Error, tags?: SentryTags) {
  Sentry.withScope(scope => {
    if (tags) {
      Object.keys(tags).forEach(key => {
        scope.setTag(key, tags[key]);
      });
    }
    Sentry.captureException(e);
  });
}

/**
 * Use this to report severe errors that the dev team should address immediately.
 * e.g. a rendering error caught at the top-level of the app in an error boundary
 */
export function captureFatal(e: Error) {
  captureException(e, { report: 'opsgenie-high' });
}

/**
 * Some users are embedding Start on App aggregators like Rambox Pro or Shift.
 * This causes exception's stacktrace to contain the fullpath of user's disk.
 * We need to remove that path due to GDPR concerns.
 * Lukily, all these aggregators use Electron which deploys apps inside app.asar.
 */
export function sanitizeError(e: Sentry.SentryException) {
  if (e.stacktrace && e.stacktrace.frames) {
    e.stacktrace.frames.forEach(frame => {
      if (frame.filename) {
        frame.filename = frame.filename.replace(/^.*app\.asar/, '');
      }
    });
  }
}
